
define('tpl!ui/documentViewer/providers/pdfViewer/fallback/viewer', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<iframe ></iframe>";
  });
});

